<template>
    <div style="width: 600px;">
        <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            style="min-width: 1200px;"
        >
            <el-tab-pane label="旧版广告组" name="old" style="padding: 0 25px;">
            </el-tab-pane>
            <el-tab-pane label="新版广告组" name="new" style="padding: 0 25px;">
            </el-tab-pane>
        </el-tabs>
        <el-form
            ref="formData"
            :inline="true"
            :model="formData"
            :rules="rules"
            class="query-form"
            size="mini"
            label-width="140px"
        >
            <el-form-item label="广告组合编号：" prop="portfolio_id">
                <el-input
                    v-model="formData.portfolio_id"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入广告组合编号"
                ></el-input>
            </el-form-item>
            <el-form-item label="SKU：" prop="skuAll">
                <el-input
                    v-model="formData.skuAll"
                    :autosize="{ minRows: 6, maxRows: 30 }"
                    type="textarea"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入SKU(已换行分割)"
                ></el-input>
            </el-form-item>
            <el-form-item label="广告日耗：" prop="campaign_daily_budget">
                <el-input
                    v-model="formData.campaign_daily_budget"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入广告日耗"
                ></el-input>
            </el-form-item>
            <el-form-item label="竞价：" prop="max_bid">
                <el-input
                    v-model="formData.max_bid"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入竞价"
                ></el-input>
            </el-form-item>
            <el-form-item label="广告目的：" prop="ad_goal">
                <el-input
                    v-model="formData.ad_goal"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入广告目的"
                ></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <el-input
                    v-model="formData.model"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入型号"
                ></el-input>
            </el-form-item>
            <el-form-item label="词根：" prop="etyma">
                <el-input
                    v-model="formData.etyma"
                    :autosize="{ minRows: 6, maxRows: 30 }"
                    type="textarea"
                    style="width: 400px;margin-right:20px;"
                    placeholder="请输入词根(已换行分割)"
                ></el-input>
            </el-form-item>
            <el-form-item label="开始日期：" prop="start_date" v-if="isNew">
                <el-date-picker
                    v-model="formData.start_date"
                    type="date"
                    value-format="yyyyMMdd"
                    placeholder="选择日期"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float: left;margin-left: 6px;"
                size="mini"
                type="danger"
                plain
                @click="onempty()"
                >清空数据</el-button
            >
            <el-button
                style="float:right;margin-left: 30px;"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >分析数据，生成广告组</el-button
            >
        </el-row>
        <analysis
            :visible="ctrl.analysisDialogVisible"
            :formData="formData"
            :list="list"
            :isNew="isNew"
            :title="'分析数据'"
            @close-callback="closeCllback"
        ></analysis>
    </div>
</template>

<script>
import Analysis from "./analysis";
export default {
    components: { Analysis },
    data() {
        return {
            activeName: "old",
            ctrl: {
                analysisDialogVisible: false
            },
            formData: {
                start_date: null
            },
            list: [],
            isNew: false,
            rules: {
                portfolio_id: [
                    {
                        required: true,
                        message: "广告组合编号",
                        trigger: "blur"
                    }
                ],
                skuAll: [
                    {
                        required: true,
                        message: "请输入SKU",
                        trigger: "blur"
                    }
                ],
                campaign_daily_budget: [
                    {
                        required: true,
                        message: "请输入广告日耗",
                        trigger: "blur"
                    }
                ],
                max_bid: [
                    {
                        required: true,
                        message: "请输入竞价",
                        trigger: "blur"
                    }
                ],
                ad_goal: [
                    {
                        required: true,
                        message: "请输入广告目的",
                        trigger: "blur"
                    }
                ],
                model: [
                    {
                        required: true,
                        message: "请输入型号",
                        trigger: "blur"
                    }
                ],
                etyma: [
                    {
                        required: true,
                        message: "请输入词根",
                        trigger: "blur"
                    }
                ],
                start_date: [
                    {
                        required: true,
                        message: "请选择开始日期",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    methods: {
        handleClick(val) {
            val.paneName === "new" ? (this.isNew = true) : (this.isNew = false);
        },
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.formData.sku = this.formData.skuAll
                        .trim()
                        .replace(/\r\n/g, ",")
                        .replace(/\r/g, ",")
                        .replace(/\n/g, ",")
                        .replace(/,{2,}/g, ",")
                        .replace(/ /g, "");
                    let arr = this.formData.etyma.trim().split(/[(\r\n)\r\n]+/);
                    arr = [...new Set(arr)];
                    let ad_group_arr = [];
                    //获取日期
                    var myDate = new Date();
                    var time = this.isNew
                        ? this.formData.start_date
                        : myDate
                              .toLocaleDateString()
                              .split("/")
                              .join("-");
                    for (let i = 0; i < arr.length; i++) {
                        let obj = {
                            ad_group_name:
                                this.formData.ad_goal +
                                "-" +
                                arr[i] +
                                "-" +
                                this.formData.model +
                                "-" +
                                time,
                            ad_group_num: 1
                        };
                        ad_group_arr.push(obj);
                    }
                    this.list = ad_group_arr;
                    this.ctrl.analysisDialogVisible = true;
                }
            });
        },
        //清空数据
        onempty() {
            this.formData = {};
            this.list = [];
        },
        // 关闭弹窗回调
        closeCllback() {
            this.ctrl.analysisDialogVisible = false;
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped></style>
